import { Outlet } from "react-router-dom";
import bg from "../../assets/11.png";
import logo from "../../assets/TamilNadu_Logo.png";

const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <div className="relative min-h-screen flex-col items-center justify-center grid lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="relative hidden h-full flex-col p-10 text-white lg:flex dark:border-r">
          <div className="absolute inset-0" />
          <div className="h-full w-full flex flex-col gap-10 justify-center items-center absolute inset-0">
            <img src={logo} alt="Logo" className="w-24 h-24 mx-auto " />
            <h3 className="text-black text-2xl text-center font-bold">
              Department of Handlooms <br /> கைத்தறி துறை
            </h3>
            <img
              src={bg}
              alt="Background"
              className="h-[47%] w-[55%] opacity-60"
            />
          </div>
        </div>
        <div className="flex mx-auto w-full lg:w-full justify-center items-center">
          <div className="flex w-full flex-col justify-center items-center">
            <div className="flex flex-col lg:hidden my-3 lg:my-0">
              <img src={logo} alt="Logo" className="w-20 h-20 mx-auto " />
              <h3 className="text-black text-xl text-center font-bold">
                Department of Handlooms <br /> கைத்தறி துறை
              </h3>
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
